export default __webpack_public_path__ + "static/media/fa-solid-900.3ef4f1ac.woff";